import script from "./pp-special-prize-winnings.vue?vue&type=script&lang=ts&setup=true"
export * from "./pp-special-prize-winnings.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__